


































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { rgba } from 'polished';

import Typography from '@/components/atoms/Typography/Typography.vue';
import CloseIcon from '@/components/icons/Close.vue';
import CouponCardIcon from '@/components/icons/CouponCard.vue';
import WidgetPrevious from '@/components/icons/WidgetPrevious.vue';
import WidgetNext from '@/components/icons/WidgetNext.vue';
import Thumb from '@/components/molecules/Thumb/Thumb.vue';

import { EWidgetThemes, WidgetThemesDictionary } from '@/models/Widget/themes';
import { BusinessOnboardingState } from '@/models/business-onboarding';

@Component({
  components: {
    Typography,
    CloseIcon,
    CouponCardIcon,
    Thumb,
    WidgetPrevious,
    WidgetNext
  }
})
export default class WidgetPopover extends Vue {
  @Prop({ default: EWidgetThemes.BLUE }) theme!: EWidgetThemes;
  @Prop({ default: '' }) businessLogo?: string;
  @Prop({ default: '' }) device?: string;

  dots = [1, 2, 3, 4, 5, 6];

  get tPrefix() {
    return 'common.components.widgetPopoverV2';
  }

  get themeSettings() {
    return WidgetThemesDictionary[this.theme];
  }

  get getBusinessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get businessOnboardingState(): BusinessOnboardingState {
    return this.$store.getters[
      'businessOnboarding/getBusinessOnboardingState'
    ] as BusinessOnboardingState;
  }

  get firstColor() {
    if (this.isBlack) return '#DAE1EC';
    return this.themeSettings.primaryGradient.slice(27, 34);
  }

  get secondColor() {
    if (this.isBlack) return '#DAE1EC';
    return this.themeSettings.primaryGradient.slice(42, 49);
  }

  get themeColor() {
    return this.themeSettings.primaryColor;
  }

  get themePrimaryColorDarken() {
    return this.themeSettings.darkTextColor;
  }

  get themeGradientAsBackgroundStyle() {
    return {
      background: this.isBlack ? '#FFFFFF' : this.themeSettings.primaryGradient
    };
  }

  get themeBackgroundDotStyle() {
    return {
      background: this.themeSettings.dotSlide
    };
  }

  get themeGradientAsBackgroundActivedDotStyle() {
    return {
      background: this.isBlack ? '#DAE1EC' : this.themeSettings.primaryGradient
    };
  }

  get isBlack() {
    return this.theme === EWidgetThemes.BLACK;
  }

  get themePopoverStyle() {
    return {
      backgroundColor: this.themeSettings.backgroundLight
    };
  }

  get themeBackgroundStyle() {
    return {
      backgroundColor: this.themeSettings.background
    };
  }

  get themeBackgroundLightStyle() {
    return {
      backgroundColor: this.themeSettings.colorLight
    };
  }

  get themeAsBackgroundLightStyle() {
    return {
      backgroundColor: rgba(this.themeColor, 0.07)
    };
  }

  get themeAsIconBackgroundStyle() {
    return {
      background: this.themeSettings.iconBackground
    };
  }

  get themeAsCarouselBackgroundStyle() {
    return {
      backgroundColor: this.themeSettings.backgroundCarousel || '#FFF'
    };
  }

  get themeContrastColorAsColorStyle() {
    if (this.isBlack)
      return {
        color: this.themeSettings.darkTextColor
      };
    return {
      color: this.themeSettings.primaryGradientTextColor || '#FFF'
    };
  }

  get themePrimaryColorDarkenAsColorStyle() {
    return {
      color: this.themeSettings.darkTextColor
    };
  }

  get themeCarouselTextColorStyle() {
    if (this.isBlack) return '#FFFFFFDB';
    return this.themeSettings.darkTextColor;
  }

  get themePoweredTextColorStyle() {
    if (this.isBlack) return '#FFFFFF';
    return this.themeSettings.darkTextColor;
  }
}
